chatClient.directive('autoFocus', [
    '$timeout',
    function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                //'Watches' the value passed into the auto-focus attribute for any changes
                scope.$watch(
                    function () {
                        return attrs.autoFocus;
                    },
                    function (value) {
                        //Values are: 'attendee-list', 'chat-client' or 'presenter-chat-client'
                        if (value === 'chat-client' || value === 'presenter-chat-client') {
                            //Although set to 0, the timeout seems necessary
                            //to give element time to render
                            $timeout(function () {
                                element[0].focus();
                            }, 0);
                        }
                    }
                );
            }
        };
    }
]);
